export const activeTabsItems: Record<string, string[]> = {
  all: ['metrics', 'products'],
  products: ['products'],
  quotations: ['quotations'],
}

export const getTabsItems = (t: (key: string) => string) => [
  {
    key: 'all',
    title: t('supplierTabAll'),
  },
  {
    key: 'products',
    title: t('supplierTabForecast'),
  },
]
